import createServices from '~/api/services'

export default (ctx, inject) => {
  inject('services', createServices(ctx.$axios))
}
